export const GET_OPERATOR_MANAGEMENT_TABLE = "GET_OPERATOR_MANAGEMENT_TABLE";